import { useCallback, useRef } from 'react'
import noop from 'lodash/noop'
import { trpc } from '@klear/ui/lib/trpc'
import { getAppBasePath } from '@klear/runtime-env'
import { ROUTE_TRADER } from '@klear/constants'
import { traderIdFromPathname } from '@/lib/trader-path'

function dedupeKey(message: string, url: string, componentStack?: string): string {
  return `${message}|${url}|${componentStack?.slice(0, 100) ?? ''}`
}

export function useClientErrorReporting() {
  const { mutate } = trpc.clientError.report.useMutation()
  const reportedKeys = useRef(new Set<string>())

  return useCallback(
    (error: Error, info: { componentStack?: string | null }) => {
      if (error.message === 'Unauthorized') {
        return
      }

      const url = window.location.href
      const componentStack = info.componentStack ?? undefined
      const key = dedupeKey(error.message, url, componentStack)

      if (reportedKeys.current.has(key)) {
        return
      }
      reportedKeys.current.add(key)

      const traderIdStr = traderIdFromPathname(window.location.pathname, getAppBasePath(ROUTE_TRADER))
      const traderId = traderIdStr ? parseInt(traderIdStr, 10) : undefined

      mutate(
        {
          message: error.message,
          stack: error.stack,
          componentStack,
          url,
          app: 'trader',
          traderId
        },
        { onError: noop }
      )
    },
    [mutate]
  )
}
